// import Rellax from 'rellax';
/* eslint-disable-next-line no-unused-vars */
import observeIntersection from './inc/observeIntersection';
import observeIntersectionQS from './inc/observeIntersectionQS';
import initSliderBlocks from './inc/initSliderBlocks';
import initQuoteSlider from './inc/quoteSlider';
import countUp from './inc/countUp';
// import scriptLoader from './inc/scriptLoader';
import devAt from './inc/devAt';
import mobileNav from './inc/mobileNav';
import initWatchlist from './inc/watchlistHandler';

window.initPlyr = () => {
    setTimeout(() => {
        Array.from(document.querySelectorAll('.plyr:not(.plyr--video)')).map(
            // eslint-disable-next-line no-undef
            (p) => new Plyr(p, {
                controls: [
                    'play-large',
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'captions',
                    'pip',
                    'airplay',
                    'fullscreen',
                ],
            })
        );
    }, 1000);
};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

// eslint-disable-next-line no-unused-vars
let lastKnownScrollPosition = 0;
let ticking = false;

document.addEventListener('scroll', () => {
    lastKnownScrollPosition = window.scrollY;

    if (!ticking) {
        window.requestAnimationFrame(() => {
            ticking = false;
        });

        ticking = true;
    }
});

const closeMenu = () => {
    window.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
            const dropdownOrigins = document.querySelectorAll('li.dropdown-origin a.decent-link');
            if (dropdownOrigins && Array.from(dropdownOrigins).some((element) => element === document.activeElement)) {
                e.preventDefault();
                dropdownOrigins.forEach((d) => {
                    d.blur();
                });
            }
            const searchForm = document.getElementById('searchForm');
            if (searchForm.classList.contains('open')) {
                searchForm.classList.remove('open');
            }
        }
    });
};

const expansionObserver = () => {
    const targets = document.querySelectorAll('li.dropdown-origin');
    if (targets && targets.length) {
        targets.forEach((li) => {
            li.addEventListener('mouseenter', (e) => {
                e.target
                    .closest('li.dropdown-origin')
                    .setAttribute('aria-expanded', true);
            });
            li.addEventListener('focus', (e) => {
                e.target
                    .closest('li.dropdown-origin')
                    .setAttribute('aria-expanded', true);
            });
            li.addEventListener('mouseleave', (e) => {
                e.target
                    .closest('li.dropdown-origin')
                    .setAttribute('aria-expanded', false);
            });
            li.addEventListener('focusout', (e) => {
                e.target
                    .closest('li.dropdown-origin')
                    .setAttribute('aria-expanded', false);
            });
        });
    }
};

const initPlayers = () => {
    if (document.body.classList.contains('has-plyr')) {
        // eslint-disable-next-line no-unused-vars
        const players = Array.from(
            document.querySelectorAll('.videoPlayer')
            // eslint-disable-next-line no-undef
        ).map((p) => new Plyr(p));
    }
};

const teamAreaToggle = () => {
    const teamAreaButtons = document.querySelectorAll(
        '.teamDisplay a.button.in-link-list'
    );
    const teamAreas = document.querySelectorAll('nav.teamArea');
    const teamAreaControllers = document.querySelectorAll(
        '.teamAreaController'
    );

    if (teamAreaButtons) {
        teamAreaButtons.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if (teamAreas) {
                    teamAreas.forEach((area) => {
                        area.classList.remove('w--open');
                    });
                }
                if (teamAreaControllers) {
                    teamAreaControllers.forEach((ctrl) => {
                        ctrl.classList.remove('w--open');
                    });
                }
                const areaToOpen = document.getElementById(
                    `w-dropdown-list-${e.target.dataset.areaid}`
                );
                const toggleToOpen = document.getElementById(
                    `w-dropdown-toggle-${e.target.dataset.areaid}`
                );
                if (areaToOpen) {
                    areaToOpen.classList.add('w--open');
                }
                if (toggleToOpen) {
                    toggleToOpen.classList.add('w--open');
                }
            });
        });
    }
};

const employerAnchorNav = () => {
    const anchors = document.querySelectorAll('[data-scrollanchor]');
    const anchorNavJs = document.getElementById('anchorNavJs');
    const anchorNav = document.getElementById('anchorNav');
    if (anchors && anchors.length && anchorNavJs) {
        anchors.forEach((anc) => {
            const newlink = document.createElement('li');
            newlink.innerHTML = `${anc.dataset.scrolltitle}<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g opacity="0.32"><path d="M7.99992 3.33325V12.6666M7.99992 12.6666L12.6666 7.99992M7.99992 12.6666L3.33325 7.99992" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></g></svg>`;
            newlink.addEventListener('click', () => {
                window.bayScrollTo(anc.id);
                anchorNav.classList.remove('active');
                anchorNav.classList.add('clicked');

                setTimeout(() => {
                    anchorNav.classList.remove('clicked');
                }, 1000);
            });
            anchorNavJs.appendChild(newlink);
        });

        document.getElementsByClassName('anchorNav__label')[0].addEventListener('click', () => {
            anchorNav.classList.toggle('active');
        });

        document.getElementsByClassName('anchorNav__container')[0].addEventListener('mouseout', () => {
            anchorNav.classList.remove('active');
        });
    }
};

const employerFavorites = () => {
    const button = document.querySelector('[data-employer]');

    if (button) {
        const svg = button.querySelector('svg');
        const text = button.querySelector('span');
        const employerId = parseInt(button.dataset.employer, 10);
        let savedEmployers = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];

        if (savedEmployers.includes(employerId)) {
            svg.setAttribute('fill', 'currentColor');
            text.innerText = 'Gemerkt';
        }

        button.addEventListener('click', () => {
            savedEmployers = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];

            if (savedEmployers.includes(employerId)) {
                savedEmployers = savedEmployers.filter((item) => item !== employerId);
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers));
            } else {
                savedEmployers = [...savedEmployers, employerId];
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers));
            }

            window.dispatchEvent(new Event('watchlist'));
        });

        window.addEventListener('watchlist', () => {
            savedEmployers = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];

            if (savedEmployers.includes(employerId)) {
                svg.setAttribute('fill', 'currentColor');
                text.innerText = 'Gemerkt';
            } else {
                svg.setAttribute('fill', 'transparent');
                text.innerText = 'Merken';
            }
        });
    }
};

const menuColors = () => {
    // Array containing colors
    const colors = [
        '#9e58fd',
        '#4a73e4',
        '#0ed56c',
        '#70edea',
    ];

    const menuItems = document.getElementsByClassName(
        'decent-link in-navbar'
    );

    if (menuItems && menuItems.length) {
        Array.from(menuItems).forEach((itm) => {
            const randomColor = colors[Math.floor(Math.random() * colors.length)];
            itm.style.backgroundColor = randomColor;
            const parentElement = itm.parentNode;
            if (parentElement) {
                const targetElement = parentElement.nextElementSibling;
                if (targetElement) {
                    const el = targetElement.querySelector('.list-wrap');
                    if (el) {
                        el.style.backgroundColor = randomColor;
                    }
                }
            }
        });
    }
};

/* Author: herrlich media */
document.addEventListener('DOMContentLoaded', () => {
    /*++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* Ready Inits +++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/
    /* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++*/

    const externalListLinks = () => {
        const listItems = document.querySelectorAll('li.externalLink');
        if (listItems && listItems.length) {
            listItems.forEach((li) => {
                const anchors = li.querySelectorAll('a');
                if (anchors && anchors.length) {
                    anchors.forEach((a) => {
                        a.setAttribute('target', '_blank');
                    });
                }
            });
        }
    };

    // eslint-disable-next-line no-unused-vars
    window.bayScrollTo = (id) => {
        const yOffset = -200;
        const element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    };

    const initAccordion = (accordion) => {
        const buttons = accordion.querySelectorAll('.a-btn');
        buttons.forEach((btn) => {
            const containers = accordion.querySelectorAll('.a-container');
            btn.addEventListener('click', () => {
                if (btn.parentElement.classList.contains('active')) {
                    btn.parentElement.classList.remove('active');
                } else {
                    containers.forEach((ctn) => {
                        ctn.classList.remove('active');
                    });
                    btn.parentElement.classList.add('active');
                }
                setTimeout(() => {
                    const yOffset = -100;
                    const y = btn.getBoundingClientRect().top
                        + window.pageYOffset
                        + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }, 500);
            });
        });
    };

    const observeAccordions = () => {
        const accs = document.querySelectorAll('.accordion');
        if (accs && accs.length) {
            accs.forEach((acc) => {
                const elObserver = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.intersectionRatio > 0) {
                            initAccordion(acc);
                            elObserver.unobserve(entry.target);
                        }
                    });
                });
                elObserver.observe(acc);
            });
        }
    };

    window.onresize = () => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    countUp();

    initSliderBlocks('.swiper-b1');
    initQuoteSlider('.swiper-a07b');

    devAt();

    mobileNav();

    externalListLinks();

    observeAccordions();

    closeMenu();

    expansionObserver();

    initPlayers();

    employerFavorites();

    initWatchlist();

    const foldouts = document.querySelectorAll(
        '.teaser-list-element-wrapper .foldout-toggle, .w-dropdown-toggle'
    );

    if (foldouts && foldouts.length) {
        foldouts.forEach((fo) => {
            fo.addEventListener('click', () => {
                fo.toggleAttribute('aria-expanded');
                fo.classList.toggle('w--open');
                const foldoutContent = fo.nextSibling;
                if (foldoutContent) {
                    foldoutContent.classList.toggle('w--open');
                }
            });
        });
    }

    teamAreaToggle();

    if (document.body.classList.contains('single-employer')) {
        employerAnchorNav();
    }

    // fade In observer
    observeIntersectionQS(
        '.fadeIn',
        (e, intersected) => {
            if (intersected) {
                if (!e.target.classList.contains('vis')) {
                    e.target.classList.add('vis');
                }
            }
        },
        true
    );

    observeIntersectionQS(
        '.fadeInRow',
        (e, intersected) => {
            if (intersected) {
                const objects = e.target.querySelectorAll(
                    ':scope > div, :scope > li, :scope > p, :scope > a, :scope > h1, :scope > h2, :scope > h3, :scope > img'
                );
                if (objects) {
                    objects.forEach((el, index) => {
                        if (!el.classList.contains('vis')) {
                            setTimeout(() => {
                                el.classList.add('vis');
                            }, 150 * index);
                        }
                    });
                }
            }
        },
        true
    );

    menuColors();
}); /* ready end ++++++++++++++++++++++++++++++++++++++++++*/
